import {ErrorHandler, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';

@Injectable()
export class ErrorService implements ErrorHandler {

  private readonly _errorOccurredSubject: ReplaySubject<any> = new ReplaySubject();

  constructor() {
  }

  public get errorOccurred(): Observable<any> {
    return this._errorOccurredSubject.asObservable();
  }

  public handleError(error: any): void {
    console.error(error);
    this._errorOccurredSubject.next(error);
  }

  public catchError<T, A extends Array<any>, R>(callback: (...params: A) => R, thisArg?: T, ...params: A): void {
    try {
      callback.apply<T | undefined, A, R>(thisArg, params);
    } catch (e) {
      this.handleError(e);
    }
  }
}
